<template>
  <div class="week-by-car-num">
    <div class="mark" v-if="mark">
      <el-progress type="circle" :percentage="progressNum" class="circle" style="color:#fff;"></el-progress>
    </div>
    <div class="wrapper">
      <div class="header">
        <el-form :inline="true" label-width="60px">
          <el-form-item label="统计周期" label-width="75px">
            <el-date-picker
                    v-model="selectDateVal"
                    format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetimerange"
                    range-separator="~"
                    :clearable="false"
                    :picker-options="pickerOptions"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="省市" label-width="75px">
            <el-cascader
                v-if="areaListPr.length>0"
                :options="areaListPr"
                v-model="formData.provCityCounty"
                :props="propsData()"
                clearable></el-cascader>
          </el-form-item>
          <el-form-item label="" label-width="75px">
            <el-input v-model="formData.phone" clearable placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item label="" label-width="75px">
            <el-input v-model="formData.userName" clearable placeholder="请输入用户名"></el-input>
          </el-form-item>
          <el-button style="margin-left:30px;" @click="getData(true)">查询</el-button>
          <el-button style="margin-left:20px;" @click="exportData">导出</el-button>
        </el-form>
      </div>
      <el-table ref="singleTable" :data="tableData" :max-height="tableHeight" stripe style="width: 100%">
        <el-table-column type="index" label="序号" align="center" width="50" fixed="left"/>
        <el-table-column prop="provinceName" label="省" align="center"></el-table-column>
        <el-table-column prop="cityName" label="市" align="center"></el-table-column>
        <el-table-column prop="phone" label="手机号" align="center"></el-table-column>
        <el-table-column prop="userName" label="用户名" align="center"></el-table-column>
        <el-table-column prop="receiveOperateNum" label="领取操作数" align="center"></el-table-column>
        <el-table-column prop="cancelOperateNum" label="退订操作数" align="center"></el-table-column>
        <el-table-column prop="devSuccessOperateNum" label="开发成功操作数" align="center"></el-table-column>
        <el-table-column prop="devFailOperateNum" label="开发失败操作数" align="center"></el-table-column>
      </el-table>
      <div class="pageBlock">
        <el-pagination @current-change="onChangePage" :current-page.sync="index" :page-size="pageSize"
                       layout="prev, pager, next, jumper" :total="total" style="margin:auto;"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
// import areaList from './components/areaList'

import WeekPopover from '../../freight/weekByCarNum/components/weekPopover.vue'
import WeekDialog from '../../freight/weekByCarNum/components/weekDialog.vue'
import Util from '@/utils/util'
import {collectAnalysisCustomerPage, collectAnalysisCustomerEx,collectAnalysisCustomerEx2,progress} from "@/api/log";
import http from '@/api/freight' // 请求汇总
import Cookies from "js-cookie";

export default {
  name: 'week-by-car-num',
  components: {WeekPopover, WeekDialog},
  data() {
    return {
      showWeekDialog: false,
      mark: false, //遮罩层开关
      progressNum: 0, //下载进度条进度
      formData: {
        phone:'',
        devUser:'',
        provCityCounty:[],
      },
      areaListPr: [],
      selectDate: '',
      selectDateVal: [],
      pickerOptions: {
        onPick: ({maxDate, minDate}) => {
          this.selectDate = minDate.getTime()
          if (maxDate) {
            this.selectDate = ''
          }
        },
        disabledDate: (time) => {
          if (time.getTime() >= new Date().getTime()) {
            return true // 禁用该日期 今天之后的时间不可选
          }
          if (this.selectDate !== '') {
            const one = 92 * 24 * 3600 * 1000
            const minTime = this.selectDate - one
            const maxTime = this.selectDate + one
            return time.getTime() < minTime || time.getTime() > maxTime
          }
        }
      },

      curDate: '',

      tableData: [],

      total: 0, // 总页数
      index: 1, // 当前页数
      pageSize: 20,
    }
  },
  computed: {
    areaList() {
      let nerArr = JSON.parse(JSON.stringify(this.$store.getters.areaList))
      if (nerArr.length > 0) {
        nerArr.forEach(item => {
          item.provinceCode = item.provinceCode + '0000'
        })
      }
      return nerArr
    },
  },
  mounted() {
    const end = new Date();
    end.setHours(23, 59, 59, 0);

    const start = new Date();
    start.setDate(end.getDate() - 6);
    start.setHours(0, 0, 0, 0);

    const begin = Util.format(start.getTime(), "yyyy-MM-dd hh:mm:ss")
    const endVal = Util.format(end.getTime(), "yyyy-MM-dd hh:mm:ss")
    this.selectDateVal = [begin, endVal]
    this.getData()
    this.getPrInter()
  },
  methods: {
    async getPrInter() {
      const {data} = await http.getCountyAreaList({code: '0', type: '1', areaType: 'PROVINCE'})
      this.areaListPr = data
          .map(item => ({
            value: item.code,
            label: item.name,
            leaf: false
          }));
      if (this.areaListPr.length == 1) {
        this.cardNum = Util.keyValueCardNum[this.areaListPr[0].value.substring(0, 2)]
      }
    },
    getCiInter(code, level) {
      return new Promise(async resolve => {
        const {data} = await http.getCountyAreaList({code, type: '1', areaType: 'CITY'})
        const nodes = data
            .map(item => ({
              value: item.code,
              label: item.name,
              leaf: true
            }));
        nodes.push({
          value: '-1',
          label: '其他',
          leaf: true
        })
        resolve(nodes);
      })
    },
    getCuInter(code, level) {
      return new Promise(async resolve => {
        const {data} = await http.getCountyAreaList({code, type: '1', areaType: 'COUNTY'})
        const nodes = data
            .map(item => ({
              value: item.code,
              label: item.name,
              leaf: true
            }));
        nodes.push({
          value: '-1',
          label: '其他',
          leaf: true
        })
        resolve(nodes);
      })
    },
    propsData() {
      const vm = this
      return {
        lazy: true,
        checkStrictly: true,
        expandTrigger: 'hover',
        async lazyLoad(node, resolve) {
          const {level, value} = node;
          if (level === 1) {
            resolve(await vm.getCiInter(value, level));
          }else {
            resolve([])
          }
        }
      }
    },
    onChangePage(index) {
      this.index = index
      this.getData()
    },
    getData(flag) {
      if (flag) {
        this.index = 1
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      collectAnalysisCustomerPage({
        provinceCode: this.formData.provCityCounty[0] || '',
        cityCode: this.formData.provCityCounty[1] || '',
        phone: this.formData.phone || '',
        userName: this.formData.userName || '',
        pageNum: this.index,
        pageSize: this.pageSize,
        startTime: this.selectDateVal ? new Date(this.selectDateVal[0]).getTime() : '',
        endTime: this.selectDateVal ? new Date(this.selectDateVal[1]).getTime() : ''
      })
          .then((e) => {
            loading.close();
            if (200 != e.code) {
              this.$message({
                message: e.message || '数据获取出错',
                type: 'error',
              })
              return
            }
            let typeText = {
              0: '石化总部', 1: '石化省市公司', 2: '石化地市(片区)公司', 3: '中交兴路'
            }
            e.data.dataList.forEach(item => {
              item.cityName = item.cityName?item.cityName:'-'
            })
            this.tableData = e.data.dataList
            this.index = e.data.pageNum
            this.total = e.data.total
          })
          .catch((err) => {
            console.error(err)
            this.curDate = ''
          })
    },
    exportData() {
      let that = this
      that.mark = true
      let reqId = Cookies.get('user')
      reqId += new Date() * 1
      let times
      times = setInterval(function () {
        progress({reqId}).then(e => {
          that.progressNum = e.data.percent
          if (e.data.percent >= 100) {
            clearInterval(times)
            that.progressNum = 100
            setTimeout(function () {
              that.mark = false
              that.progressNum = 0
            }, 500);
          }
        })
      }, 200)
      window.location.assign(
              collectAnalysisCustomerEx2({
                provinceCode: this.formData.provCityCounty[0] || '',
                cityCode: this.formData.provCityCounty[1] || '',
                phone: this.formData.phone || '',
                userName: this.formData.userName || '',
                pageNum: this.index,
                pageSize: this.pageSize,
                startTime: this.selectDateVal ? new Date(this.selectDateVal[0]).getTime() : '',
                endTime: this.selectDateVal ? new Date(this.selectDateVal[1]).getTime() : '',
                reqId
              })
      )
    },
    onWeekDialogCommand() {
      window.location.assign(collectAnalysisCustomerEx({
        provinceCode: this.formData.provCityCounty[0] || '',
        cityCode: this.formData.provCityCounty[1] || '',
        phone: this.formData.phone || '',
        userName: this.formData.userName || '',
        pageNum: this.index,
        pageSize: this.pageSize,
        startTime: this.selectDateVal ? new Date(this.selectDateVal[0]).getTime() : '',
        endTime: this.selectDateVal ? new Date(this.selectDateVal[1]).getTime() : ''
      }))
    },
  },
}
</script>

<style lang="stylus" scoped>
.wrapper {
  padding: 20px;
  background: #fff;

  .header {
    margin-bottom: 20px;
  }
}

.pageBlock {
  display: flex;
  margin-top: 20px;
}

.mark {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  background: rgba(0, 0, 0, 0.7);
  z-index: 100;

  .circle {
    margin: auto;
  }
}
</style>
